/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Accordion from '../../../../components/Accordion';
import Table, { ColumnDefinitionType } from '../../../../components/Table';
import { PersonalHabilitacion } from '../../../../types/PersonalHabilitacion';
import { usePersonalHabilitacion } from '../../../../hooks/usePersonalHabilitacion';
import { useHabilitacionContratista } from '../../../../hooks/useHabilitacionContratista';
import MyModal from '../../../../components/Modal';
import { Button } from 'react-bootstrap';
import { AgregarPersonaHabilitacion } from './agregar';
import { toast } from 'react-toastify';
import { cargarCombo, findAll } from '../../../../services/Service';
import { useUserLogin } from '../../../../hooks/useUserLogin';
import {
    EN_PROCESO_STATUS_ID,
    HAB_OBSERVADA_STATUS_ID,
    HAB_REVISION_STATUS_ID,
    OK_DOCUMENTO_STATUS,
    NO_OK_DOCUMENTO_STATUS,
} from '../../../../constants/constants';

type PersonalHabilitacionProps = {
    isDisabled?: boolean;
    isEdit?: boolean;
    puedeCalificar?: boolean;
};

const PersonalHabilitacionComponent: React.FC<PersonalHabilitacionProps> = ({
    isDisabled = false,
    isEdit = true,
    puedeCalificar = false,
}) => {
    const { habilitacionSelected } = useHabilitacionContratista();
    const {
        personalList,
        personalSelected,
        buscarPersonalByIdHabilitacion,
        eliminarPersonal,
        handlePersonalSelected,
        handleClearPersonal,
    } = usePersonalHabilitacion();
    const {
        isContratistaTipoUsuario,
        isEmpresaGestoraTipoUsuario,
        isEmpresaSupervisoraTipoUsuario,
    } = useUserLogin();
    const estadoActual = habilitacionSelected.idTipoEstado;
    const puedeEliminar = !isDisabled && estadoActual === EN_PROCESO_STATUS_ID;

    const [cargado, setCargado] = useState(false);
    const [isOpenAddPersona, setIsOpenAddPersona] = useState(false);
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
    const [isOpenEditPersona, setIsOpenEditPersona] = useState(false);
    const [isViewMode, setIsViewMode] = useState(false);
    // Modo "calificar": la empresa gestora/supervisora abre la edición en Revisión solo
    // para calificar documentos; los datos de la persona quedan en solo lectura.
    const [isCalificarMode, setIsCalificarMode] = useState(false);
    const [tiposDocPersona, setTiposDocPersona] = useState<any[]>([]);
    const [docsObligatoriosPersonal, setDocsObligatoriosPersonal] = useState<any[]>([]);

    const toggleAddPersona = () => setIsOpenAddPersona(!isOpenAddPersona);
    const toggleDeleteModal = () => setIsOpenDeleteModal(!isOpenDeleteModal);
    const toggleEditPersona = () => {
        if (isOpenEditPersona) {
            handleClearPersonal();
            setIsCalificarMode(false);
            // Al cerrar el modal recargamos el personal para reflejar el semáforo
            // recalculado por el backend tras calificar documentos.
            buscarPersonalByIdHabilitacion(habilitacionSelected.id);
        }
        setIsOpenEditPersona(!isOpenEditPersona);
    };

    useEffect(() => {
        cargarCombo('tiposDocPersona', setTiposDocPersona);
    }, []);

    useEffect(() => {
        if (habilitacionSelected.idEmpresaGestora) {
            findAll(
                `documentos-personal-contratista/find?idEmpresaGestora=${habilitacionSelected.idEmpresaGestora}&soloActivos=true`
            ).then((response) => {
                if (response && response.data) {
                    setDocsObligatoriosPersonal(response.data);
                }
            });
        }
    }, [habilitacionSelected.idEmpresaGestora]);

    const handleClick = (
        event: React.MouseEvent<HTMLDivElement, MouseEvent>
    ) => {
        event.preventDefault();
        if (!cargado) {
            buscarPersonalByIdHabilitacion(habilitacionSelected.id);
            setCargado(true);
        }
    };

    const handleConfirmDeletePersona = () => {
        eliminarPersonal(
            personalSelected.id.toString(),
            habilitacionSelected.id
        ).then(() => {
            toast.success('Personal eliminado correctamente');
            toggleDeleteModal();
        }).catch(() => {
            toast.error('Error al eliminar el personal');
        });
    };

    const columns: ColumnDefinitionType<
        PersonalHabilitacion,
        keyof PersonalHabilitacion
    >[] = [];

    columns.push({ key: 'apellido', header: 'Apellido' });
    columns.push({ key: 'nombre', header: 'Nombre' });
    columns.push({ key: 'tipoDocPersona', header: 'Tipo Doc.' });
    columns.push({ key: 'nroDocumento', header: 'Nro. Documento' });
    columns.push({ key: 'situacionContractual', header: 'Situación Contractual' });
    columns.push({
        key: 'id',
        header: 'Acciones',
        cell: (data: PersonalHabilitacion) => (
            <>
                <Link
                    title="Visualizar"
                    to="#"
                    onClick={(e) => {
                        e.preventDefault();
                        handlePersonalSelected(data);
                        setIsViewMode(true);
                        setIsCalificarMode(false);
                        setIsOpenEditPersona(true);
                    }}
                >
                    <i className="fa fa-eye text-secondary me-2" aria-hidden="true" />
                </Link>
                {(!isDisabled || puedeCalificar) && (
                    <Link
                        title="Editar"
                        to="#"
                        onClick={(e) => {
                            e.preventDefault();
                            handlePersonalSelected(data);
                            setIsViewMode(false);
                            // Si no puede editar datos (gestora/supervisora en Revisión),
                            // abre en modo calificar: datos en solo lectura, califica documentos.
                            setIsCalificarMode(isDisabled && puedeCalificar);
                            setIsOpenEditPersona(true);
                        }}
                    >
                        <i className="fa fa-pencil text-secondary me-2" aria-hidden="true" />
                    </Link>
                )}
                {puedeEliminar && (
                    <a
                        href="#"
                        title="Eliminar"
                        onClick={() => {
                            handlePersonalSelected(data);
                            toggleDeleteModal();
                        }}
                    >
                        <i
                            className="fa fa-trash text-secondary me-2"
                            aria-hidden="true"
                        ></i>
                    </a>
                )}
            </>
        ),
    });

    if (
        (isContratistaTipoUsuario() && estadoActual === HAB_OBSERVADA_STATUS_ID) ||
        ((isEmpresaGestoraTipoUsuario() || isEmpresaSupervisoraTipoUsuario()) &&
            estadoActual === HAB_REVISION_STATUS_ID)
    ) {
        columns.push({
            key: 'statusDocumento',
            header: '',
            statusAprobadoValue: OK_DOCUMENTO_STATUS,
            statusNoAprobadoValue: NO_OK_DOCUMENTO_STATUS,
        });
    }

    const columnsDocsObligatorios: ColumnDefinitionType<any, any>[] = [
        { key: 'nombre', header: 'Tipo de Documento' },
        { key: 'obligatorio', header: 'Obligatorio', customBooleanRender: (value: boolean) => (value ? 'Si' : 'No') },
        { key: 'fechaEditable', header: 'Fecha Venc. Requerida', customBooleanRender: (value: boolean) => (value ? 'Si' : 'No') },
    ];

    return (
        <>
            <MyModal
                isOpen={isOpenDeleteModal}
                toggle={toggleDeleteModal}
                title="Advertencia"
                cancelButton={true}
                secondButton={true}
                secondButtonTitle={'Aceptar'}
                titleCancelar={'Cancelar'}
                secondButtonFn={handleConfirmDeletePersona}
            >
                <label>Confirma la eliminación del registro?</label>
            </MyModal>
            <MyModal
                isOpen={isOpenAddPersona}
                toggle={toggleAddPersona}
                title="Agregar Persona"
                enabledFooter={false}
                size="xl"
                scrollable={true}
            >
                <AgregarPersonaHabilitacion
                    tiposDocPersona={tiposDocPersona}
                    cancelButtonFn={toggleAddPersona}
                    saveCompletedButtonFn={toggleAddPersona}
                />
            </MyModal>
            <MyModal
                isOpen={isOpenEditPersona}
                toggle={toggleEditPersona}
                title={isViewMode ? 'Ver Persona' : 'Editar Persona'}
                enabledFooter={false}
                size="xl"
                scrollable={true}
            >
                <AgregarPersonaHabilitacion
                    tiposDocPersona={tiposDocPersona}
                    cancelButtonFn={toggleEditPersona}
                    saveCompletedButtonFn={toggleEditPersona}
                    isDisabled={isViewMode || isCalificarMode}
                    soloLectura={isViewMode}
                />
            </MyModal>
            <Accordion
                id={'personalHabilitacion'}
                title="Personal del Contratista"
                collapsed={true}
                handleClick={handleClick}
            >
                <div>
                    <div className="p-3">
                        <div className="row">
                            <div className="col-md-12 text-start align-bottom">
                                <span>Documentos Requeridos para el Personal</span>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <Table data={docsObligatoriosPersonal} columns={columnsDocsObligatorios} />
                        </div>
                    </div>
                    <div className="p-3">
                        <div className="row">
                            <div
                                className="col-md-6 text-start align-bottom"
                                style={{ alignSelf: 'flex-end' }}
                            >
                                <span>Personal</span>
                            </div>
                            <div className="col-md-6 text-end">
                                {!isDisabled && (
                                    <Button
                                        className="btn-secondary"
                                        variant="secondary"
                                        onClick={toggleAddPersona}
                                    >
                                        Agregar Persona
                                    </Button>
                                )}
                            </div>
                        </div>
                        <div className="table-responsive">
                            <Table data={personalList} columns={columns} />
                        </div>
                    </div>
                </div>
            </Accordion>
        </>
    );
};

export default PersonalHabilitacionComponent;
